<template>
	<Modal 
	:title="current == 'new' ? 'NOVA CONFIGURAÇÃO' : 'ALTERAR CONFIGURAÇÃO'"
	:loading="loading"
	@close="close"
	@save="save">		
		<div class="row">
			<div class="col-xs">
				<FormInput type="text" label="Nome" icon="fa-cog" v-model="form.name" ref="config_name" />
			</div>
		</div>
        <div class="row">
            <div class="col-xs">
                <button class="add-field" @click="addField">
                    <i class="fa fa-plus"></i> ADICIONAR CAMPO
                </button>
            </div>
        </div>
        <div class="col-xs field-list">
            <div class="row field-list-item" v-for="(field, index) in form.value" :key="index">
                <div class="col-xs-12 col-lg-12">
                    <button class="remove-field" @click="removeField(index)"><i class="fa fa-trash"></i></button>
                </div>
                <div class="col-xs-12 col-lg-4">
                    <FormInput v-model="field.name" label="Campo" type="text" :required="true" ref="field_name" />
                </div>
                <div class="col-xs-12 col-lg-8">
                    <FormInput v-model="field.value" label="Valor" type="text" :required="true" ref="field_value" />
                </div>
            </div>
        </div>
	</Modal>
</template>

<script>
import Api from "@/lib/Api";

import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";

export default {
	name: "AdminSettingForm",

	props: [ "current" ],

	components: { Modal, FormInput },

	data: function() {
		let data = {
			loading: false,
		};

		if (this.current == 'new') {
			data.form = {
				name: "",
				value: [],
			}
		} else {
			data.form = {
				id: this.current.id,
				name: this.current.name,
				value: JSON.parse(this.current.value),
			}
		}

		return data;
	},

	methods: {
        // Retorna menssagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        // Valida os campos
		/**
		 * Campos necessários
		 * login_request_id: id da conexão com o whatsapp
		 * token: token da sessão da conexão
		 */
        validation: function() {
            let data = {
                id: 0,
                name: "",
                value: [],
            };

            let error = false;

			if (this.current != 'new') {
				data.id = this.current.id;
			}

            if (this.form.name == "") {
                this.$notification.error(this.message("NOME"));
				this.$refs.config_name.validate();
                error = true;
            } else {
                data.name = this.form.name;
            }
            
			if (Object.keys(this.form.value).length > 0) {
				let dataValue = [];

				for (let i = 0; i < Object.keys(this.form.value).length; i++) {
					if (this.form.value[i].name == "") {
						this.$refs.field_name[i].validate();
						this.$notification.error(this.message("NOME DO CAMPO"));
						error = true;
					}
					
					if (this.form.value[i].value == "") {
						this.$refs.field_value[i].validate();
						this.$notification.error(this.message("VALOR DO CAMPO"));
						error = true;
					}
					
					if (!error) {
						dataValue.push({
							name: this.form.value[i].name.trim(),
							value: this.form.value[i].value.trim(),
						});
					}
                }

				data.value = dataValue;
            }

            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return data;
            }
        },

        // Salva a instância atual
		save: async function() {
            let form = this.validation();
			
			if (form == null) {
				return;
			}

            let response = null;

			this.loading = true;
			try {
				if (form.id != 0) {
					response = await Api.post_admin("setting/save", form);
				} else {
					response = await Api.post_admin("setting/create", form);
				}
            } catch (ex) {
                console.log(ex);
                this.$notification.error("Não foi possível salvar o registro.");
                return;
            }
			this.loading = false;

			if (response.error) {
				this.$notification.error(response.data);
				return;
			}

			this.$notification.success("Salvo com sucesso.");

			this.$parent.load();
			this.close();
		},

        // Adiciona um subformulário para um item de configuração
		addField: function() {
			let newField = {
				name: "",
				value: "",
			};
			this.form.value.push(newField);
		},

        // Remove um subformulário de item de configuração
		removeField: function(index) {
			this.form.value.splice(index, 1);
		},
        
        // Fecha o modal
		close: function() {
			this.$parent.showForm = false;
			this.$parent.current = false;
		}
	},
}
</script>

<style scoped>
.add-field {
	margin-top: 10px;
	border: none;
	background: #000;
	color: #d9d9d9;
	font-weight: bold;
	font-size: 12px;
	padding: 10px 15px;
}

.remove-field {
	float: right;
	background-color: red;
	color: #fff;
	font-weight: 700;
	font-size: 12px;
	border: none;
	padding: 5px 15px;
}

.field-list {
	margin-bottom: 15px;
	border: 1px solid black;
}

.field-list-item {
	padding: 10px;
	border-top: 1px solid black;
	border-bottom: 1px solid black;
}
</style>